import * as moment from "moment";
import * as ReactGA from "react-ga";
import FileDownload from "js-file-download";
import { apiService } from "./apiService";
import { momentToString } from "../utils/utils";
import { IntervalTypes } from "../utils/intervals";

export enum ReportTypes {
  CASES = "cases",
  ALERTS = "alerts",
  PROVIDERS = "providers",
  MATCHES = "matches",
  GEOSEARCH = "geosearch"
}

export enum CaseReportsOptions {
  MISSING_COUNTRY = "missingCountry",
  MISSING_CITY = "missingCity",
  CASE_TYPE = "caseType",
  CHILDREN_SEX = "childrenSex",
  CASES_BY_YEAR = "casesByYear",
  COMPANION_TYPE = "companionType",
  CLOSE_REASONS = "closeReasons",
  CASES_BY_WEEK = "casesByWeek",
  MONTHLY_HIGHLIGHTS = "monthlyHighlights"
}

export enum AlertReportsOptions {
  ALERTED_CASES_CLOSED = "alertedCasesClosed",
  DAILY_CLICKS = "dailyClicks",
  DAILY_IMPRESSIONS = "dailyImpressions",
  CLICKS_BY_COUNTRY = "clicksByCountry",
  IMPRESSIONS_BY_COUNTRY = "impressionsByCountry",
  STOP_REASONS = "stopReasons"
}

export enum MatchReportsOptions {
  DAILY_MANUAL_MATCHES = "dailyManualMatches",
  DAILY_MANUAL_SEARCHES = "dailyManualSearches",
  DAILY_AUTOMATIC_MATCHES = "dailyAutomaticMatches",
  MANUAL_MATCHES_BY_AGENCY = "manualMatchesByAgency",
  MANUAL_SEARCHES_BY_AGENCY = "manualSearchesByAgency",
  MANUAL_MATCHES_BY_PROVIDER = "manualMatchesByProvider",
  MANUAL_SEARCHES_BY_PROVIDER = "manualSearchesByProvider"
}

export enum GeoSearchReportsOptions {
  MANUAL_PHOTOS_RESULTS_BY_AGENCY = "manualPhotosResultsByAgency"
}

export enum ProvidersReportsOptions {
  ICMEC = "ICMEC",
  WEBIQ = "WEBIQ"
}

export interface IReportFilters {
  agencyCode?: string;
  state?: string;
  range?;
  interval?: IntervalTypes;
  year?: number;
}

type ReportOptions = CaseReportsOptions | AlertReportsOptions | MatchReportsOptions | ProvidersReportsOptions;

export const ReportsService = {
  get: (type: ReportTypes, report: ReportOptions, filters: IReportFilters): Promise<any> => {
    return apiService.post("/api/reports", { type, report, ...filters }).then(res => {
      FileDownload(res.data, `report-${type}-${momentToString(moment())}.csv`);
      ReactGA.event({
        category: "Report",
        action: `${type} report`,
        label: "Reports management"
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/share/services/reports.ts